<section class="pt-7">
  <div class="mask-curve-top bg-gray-light py-14">
    <div class="centered-with-padding">
      <div class="pb-7">
        <app-title
          [title]="{ text: 'COMPONENT.LISTING-AUTRES-FACADES.OTHER_FRONTS' | translate, as: 'span' }"
          size="h2" />
      </div>
      <div class="grid grid-cols-1 gap-3 desk:grid-cols-4 desk:gap-y-4">
        @for (otherFront of otherFronts(); track $index) {
          <a [routerLink]="otherFront.url" class="block h-[276px]">
            <app-option-card [image]="otherFront.image">
              <div card-title-left>{{ otherFront.name }}</div>
              <div card-title-right>
                <div class="flex gap-x-0.5">
                  @for (i of otherFront.costLevel | generateRange; track i) {
                    <app-svg [height]="23" [width]="23" src="assets/icons/badge-price.svg" />
                  }
                </div>
              </div>
            </app-option-card>
          </a>
        }
      </div>
    </div>
  </div>
</section>
